import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Azure extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M11.1,19l5.659-1,.054-.011-2.911-3.463c-1.6-1.9-2.912-3.47-2.912-3.479S14,2.747,14.016,2.718c.006-.01,2.052,3.522,4.959,8.561l4.987,8.644.038.066H5.5Z" />
        <path d="M0,17.941s1.372-2.386,3.048-5.292L6.1,7.367,9.649,4.386C11.6,2.746,13.206,1.4,13.213,1.4a.7.7,0,0,1-.057.144L9.3,9.817,5.51,17.943l-2.755,0C1.24,17.948,0,17.946,0,17.941Z" />
      </svg>
    );
  }
}

export default Azure;
